import { Checkbox } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { CardContentWrapper } from '../../../../../solceller/form/components/styledComponents';
import { VarmesentralRadio } from '../../common/varmesentralRadio';
import { OppvarmingFormData } from '../../../../types';
import { ServiceSisteToArRadio } from '../../common/serviceSisteToArRadio';
import { VarmesystemBrukCheckboxes } from '../../common/varmesystemBruk';
import { useGassValidation } from '../useGassValidation';
import { InstallertIOppvarmetRomRadio } from '../../common/installertIOppvarmetRomRadio';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

import { Fordelingssystem } from './fordelingssystem';

export const Gasskjel = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateGassSelection } = useGassValidation();

  const gassKjelSelected = watch('gass.value.kjel.selected');
  const oppvarmingBrukSelection = watch(`gass.value.kjel.value.bruk`);
  const showVarmesentral = oppvarmingBrukSelection?.romoppvarming;

  return (
    <StyledCard isActive={gassKjelSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!formState.errors.gass?.value?.kjel?.selected}
          label={t('gass.kjel.label')}
          {...register('gass.value.kjel.selected', {
            validate: validateGassSelection,
            deps: ['gass.value.kamin.selected'],
            shouldUnregister: true
          })}
        />
        {gassKjelSelected && (
          <Fragment>
            <InstallasjonsArRadio
              name={`gass.value.kjel.value.varmesentral`}
              translationKeyPrefix={`form.oppvarming.gass.kjel.varmesentral.installasjonsAr`}
            />
            <VarmesentralRadio name="gass.value.kjel.value.varmesentral.varmesentralType" />
            <InstallertIOppvarmetRomRadio name="gass.value.kjel.value.varmesentral.installertIOppvarmetRom" />

            <InstallasjonsArRadio
              name={`gass.value.kjel.value`}
              translationKeyPrefix={`form.oppvarming.gass.kjel.installasjonsAr`}
            />
            <ServiceSisteToArRadio name="gass.value.kjel.value.serviceGjennomfortSiste2Ar" />

            <VarmesystemBrukCheckboxes name="gass.value.kjel.value.bruk" />

            {showVarmesentral && <Fordelingssystem />}
          </Fragment>
        )}
      </CardContentWrapper>
    </StyledCard>
  );
};
